import { TECH_PROJECT_NAME } from 'hooks/permission/constants';
import type { ProjectNames } from 'hooks/permission/types';

import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import Notifications from '@mui/icons-material/Notifications';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SettingsBackupRestore from '@mui/icons-material/SettingsBackupRestore';

import { AuditLogs, NotificationsLink, ProjectsLink, UsersLink } from 'constants/routerPath';

import type { MenuGroup } from './types';

const admin: MenuGroup = {
    id: 'group-admin',
    title: 'Admin',
    type: 'group',
    children: [
        {
            id: 'projects',
            title: 'Projects',
            type: 'item',
            url: ProjectsLink,
            icon: BusinessCenterIcon,
            breadcrumbs: false,
            permission_name: 'project',
        },
        {
            id: 'users',
            title: 'Users',
            type: 'item',
            url: UsersLink,
            icon: PeopleAltIcon,
            breadcrumbs: false,
            permission_name: 'users',
        },
        {
            id: 'audit-log',
            title: 'Audit logs',
            type: 'item',
            url: AuditLogs,
            icon: SettingsBackupRestore,
            breadcrumbs: false,
            permission_name: 'audit-log',
        },
        {
            id: 'notifications',
            title: 'Notifications',
            type: 'item',
            url: NotificationsLink,
            icon: Notifications,
            breadcrumbs: false,
            permission_name: 'notifications',
            requiredProject: TECH_PROJECT_NAME as ProjectNames,
        },
    ],
};

export default admin;
